<div>
	<img [src]="imagePath" alt="Rewards info" />
	<p>{{ roundelText?.heading }}</p>
	<p class="small">{{ roundelText?.subText }}</p>
</div>
